import { useParams } from 'react-router-dom';
import { useFetchModelScenarios } from '../../../hooks/useFetchModelScenarios';
import { CenteredLoader } from '../../../components/CenteredLoader/CenteredLoader';
import { useFetchScenario } from '../../../hooks/useFetchScenario';
import { InputParameters } from '../../Simulation/InputParameters';
import * as Styled from './SimulationView.styled';

export const SimulationParametersView = () => {
  const { modelId } = useParams<{ modelId: string }>();

  const { data: scenarios, isLoading: scenariosLoading } =
    useFetchModelScenarios(modelId);

  const scenarioId = scenarios?.[0]?.scenario_id;

  const { data: scenario } = useFetchScenario(scenarioId);

  if (scenariosLoading) {
    return <CenteredLoader size={24} />;
  }

  return (
    <Styled.Container>
      {scenario && <InputParameters scenario={scenario} hideDescription />}
    </Styled.Container>
  );
};
